import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {MODAL_VIEW_STATE, VIEW_STATE} from "../utils/enums";
import utils from "../utils";
import toast from "../utils/toast";

const slice = createSlice({
    name: 'question',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        listViewState: VIEW_STATE.LOADING,
        modalViewState: MODAL_VIEW_STATE.NOT_LOADING,
        questions: [],
        hasMore: true,
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },setModalViewState: (state, action) => {
            state.modalViewState = action.payload
        },
        setListViewState: (state, action) => {
            state.listViewState = action.payload
        },
        setQuestions: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.questions = action.payload
            state.listViewState = VIEW_STATE.LOADED
        },
        addQuestions: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.questions = [...state.questions, ...action.payload]
        },onError: (state, action) => {
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            toast.error(action.payload);
        },
    },
});

export default slice.reducer
const {setViewState, setQuestions, addQuestions,setListViewState,setModalViewState,onError} = slice.actions

export const getCourseQuestions = (courseId,page) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.course.getCourseQuestions(courseId,page)
        if (page === 0) dispatch(setQuestions(data?.data));
        else dispatch(addQuestions(data?.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
export const addCourseQuestion = (courseId,text,onSuccess,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        await api.course.addCourseQuestion(courseId,text)
        dispatch(setModalViewState(MODAL_VIEW_STATE.NOT_LOADING))
        onSuccess()
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
    }
}
